function termsAndCondition() {
    if (window.__termsAndConditionInitialized) return;
    window.__termsAndConditionInitialized = true;

    function getTermsScope(element) {
        var cartDetails = element.closest('#AjaxCartSubtotal .cart__details');
        if (cartDetails) return cartDetails;

        var newsletter = element.closest('.newsletter__container');
        if (newsletter) return newsletter;

        var form = element.closest('form');
        if (form && form.querySelector('.accept_privacy_policy')) return form;

        var customBox = element.closest('.custom-box');
        return customBox ? customBox.parentElement : null;
    }

    function updateSubmitState(scope) {
        var privacy = scope.querySelector('.accept_privacy_policy');
        var terms = scope.querySelector('.accept_terms');
        var submitBtn = scope.querySelector('.toggle-button');
        if (!privacy || !terms || !submitBtn) return;

        if (privacy.checked && terms.checked) {
            submitBtn.classList.remove('disabled-button');
        } else {
            submitBtn.classList.add('disabled-button');
        }
    }

    document.addEventListener('change', function (e) {
        if (!e.target.matches('.accept_privacy_policy, .accept_terms')) return;
        var scope = getTermsScope(e.target);
        if (scope) updateSubmitState(scope);
    });

    document.addEventListener('click', function (e) {
        var termsToggleBtn = e.target.closest('.terms-toggle-btn');
        if (!termsToggleBtn) return;

        var termsBox = termsToggleBtn.closest('.terms-with-toggle');
        if (!termsBox) return;

        var termsText = termsBox.querySelector('.terms-text');
        if (!termsText) return;

        var showMoreLabel = termsToggleBtn.getAttribute('data-show-more') || 'Show more';
        var showLessLabel = termsToggleBtn.getAttribute('data-show-less') || 'Show less';
        var expanded = termsText.getAttribute('aria-expanded') === 'true';

        termsText.classList.toggle('terms-text--collapsed', expanded);
        termsText.classList.toggle('terms-text--expanded', !expanded);
        termsText.setAttribute('aria-expanded', String(!expanded));

        termsToggleBtn.setAttribute('aria-expanded', String(!expanded));
        termsToggleBtn.setAttribute('title', expanded ? showMoreLabel : showLessLabel);
    });

    document.querySelectorAll('.accept_privacy_policy').forEach(function (privacy) {
        var scope = getTermsScope(privacy);
        if (scope) updateSubmitState(scope);
    });
}

termsAndCondition();

document.addEventListener('DOMContentLoaded', function() {
    const searchButton = document.querySelector('button[opensearch="true"]');
    const searchInput = document.querySelector('.mobile-search');
    if (searchButton) {
        searchButton.addEventListener('click', function() {
            if (window.innerWidth < 1024) { 
                if (searchInput.style.display === 'none') {
                    searchInput.style.display = 'block';
                } else {
                    searchInput.style.display = 'none';
                }
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
    const acceptPrivacyPolicyContact = document.querySelector('#accept_privacy_policy_contact');
    const contactButton = document.querySelector('.contact-button');
    if (!acceptPrivacyPolicyContact) return;
    acceptPrivacyPolicyContact.addEventListener('change', function() {
        if (acceptPrivacyPolicyContact.checked) {
            contactButton.querySelector('button').classList.remove('disabled-button');
        } else {
            contactButton.querySelector('button').classList.add('disabled-button');
        }
    });
});

function initProductAdultVerificationPopup() {
    var overlay = document.getElementById('age-confirm-overlay');
    if (!overlay) return;

    var productId = overlay.getAttribute('data-product-id');
    if (!productId) return;

    var storageKey = 'age_ok_' + productId;

    try {
        if (sessionStorage.getItem(storageKey) === '1') return;
    } catch (e) {}

    var btnOk = document.getElementById('age-confirm-btn-ok');
    var btnCancel = document.getElementById('age-confirm-btn-cancel');

    function showPopup() {
        overlay.style.display = 'flex';
        document.body.classList.add('age-confirm-open');
        setTimeout(function () {
            var firstBtn = overlay.querySelector('button');
            if (firstBtn) firstBtn.focus();
        }, 50);
    }

    function hidePopup() {
        overlay.style.display = 'none';
        document.body.classList.remove('age-confirm-open');
    }

    function goBack() {
        if (window.history.length > 1) {
            window.history.back();
        } else {
            window.location.href = '/';
        }
    }

    function isVisible() {
        return overlay.style.display !== 'none';
    }

    function trapFocus() {
        overlay.addEventListener('keydown', function (e) {
            if (e.key !== 'Tab') return;
            var focusable = overlay.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            if (!focusable.length) return;
            var first = focusable[0];
            var last = focusable[focusable.length - 1];
            if (e.shiftKey) {
                if (document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }
            } else if (document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        });
    }

    showPopup();

    if (btnOk) {
        btnOk.addEventListener('click', function () {
            try {
                sessionStorage.setItem(storageKey, '1');
            } catch (e) {}
            hidePopup();
        });
    }

    if (btnCancel) {
        btnCancel.addEventListener('click', goBack);
    }

    overlay.addEventListener('click', function (e) {
        if (e.target === overlay) goBack();
    });

    document.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && isVisible()) goBack();
    });

    trapFocus();
}

document.addEventListener('DOMContentLoaded', initProductAdultVerificationPopup);

document.addEventListener('DOMContentLoaded', function () {
    const interval = setInterval(() => {
        const whatsappButton = document.querySelector('.whatsapp-button');
        const whatsapp = document.querySelector('#whatsapp-link');
        if (!whatsappButton) {
            clearInterval(interval);
            return;
        }

        if (whatsapp) {
            clearInterval(interval);

            whatsappButton.addEventListener('click', function () {
                whatsapp.click();
            });
        }
    }, 100);
});
